import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "./index";

export const hapticTap = () => {
  if (isNative) Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
  else navigator.vibrate?.(8);
};

export const hapticThump = () => {
  if (isNative) Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
  else navigator.vibrate?.(15);
};

export const hapticSlam = () => {
  if (isNative) Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {});
  else navigator.vibrate?.(25);
};

// Raw transient for haptic textures (rumble trains, engine scores). Native
// only by design — a web vibrate spam of 40+ ticks would be noise, not feel.
export const hapticImpact = (s: "light" | "medium" | "heavy") => {
  if (!isNative) return;
  const style = s === "heavy" ? ImpactStyle.Heavy : s === "medium" ? ImpactStyle.Medium : ImpactStyle.Light;
  Haptics.impact({ style }).catch(() => {});
};

export const hapticSuccess = () => {
  if (isNative) Haptics.notification({ type: NotificationType.Success }).catch(() => {});
  else navigator.vibrate?.([10, 40, 10, 60]);
};

export const hapticError = () => {
  if (isNative) Haptics.notification({ type: NotificationType.Error }).catch(() => {});
  else navigator.vibrate?.([20, 30, 20]);
};
